import LoadMore from "./LoadMore";

export default LoadMore;
